import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralSmartParkError } from 'src/registry/types/axios';

const RESOURCE = 'sp-core/:parkingId/memberships/membership-type/:membershipTypeId/allowed-times/:allowedTimeId/';
interface DTO {
    membershipTypeId: string;
    allowedTimeId: string;
    parkingId: string;
}
const mutationFn = ({ membershipTypeId, allowedTimeId, parkingId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { membershipTypeId, allowedTimeId, parkingId }));
};

type MutationFnType = typeof mutationFn;

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as DELETE_MEMBERSHIP_TYPE_ALLOWED_TIME_RESOURCE, useMutationHook as useDeleteMembershipTypeAllowedTime };
